import type { AppConfiguration } from '@puffin/app-frame-api';
import type { ReactNode } from 'react';
import { useApplicationConfiguration } from '../../state/configuration/application-configuration';
import { ApplicationConfigurationWizard } from './ApplicationConfigurationWizard';
import { useApplicationSettings } from '../../state/configuration/application-settings';
import { ApplicationSettingsDialog } from './ApplicationSettingsDialog';

interface ApplicationConfigurationGateProps {
  children: ReactNode;
  firstName: string;
  reloadApplication?: () => void;
}

const reloadPage = () => window.location.reload();

export const ApplicationConfigurationGate = ({ children, firstName, reloadApplication = reloadPage }: ApplicationConfigurationGateProps) => {
  const { configuration, saveConfiguration } = useApplicationConfiguration();
  const { settingsOpen, closeSettings: dismissSettings } = useApplicationSettings();

  const closeSettings = (newConfiguration: AppConfiguration) => {
    dismissSettings();
    if (configuration && (configuration.team !== newConfiguration.team || configuration.role !== newConfiguration.role)) {
      saveConfiguration(newConfiguration);
      reloadApplication();
    }
  };

  if (!configuration) {
    return <ApplicationConfigurationWizard firstName={firstName} onComplete={saveConfiguration} />;
  }

  return (
    <>
      {children}
      {settingsOpen && <ApplicationSettingsDialog configuration={configuration} onClose={closeSettings} />}
    </>
  );
};
